import { Space, Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

export const ModuleInfo = ({ name, onClick, hasPermission }) => {
  return (
    <div>
      <Space className="align-center">
        <Typography.Title level={4} className="m-0">
          {name}
        </Typography.Title>
        {hasPermission && (
          <Button
            type="primary"
            shape="circle"
            size="small"
            icon={<PlusOutlined />}
            onClick={onClick}
          />
        )}
      </Space>
    </div>
  );
};
